<div class="p-d-flex p-jc-center">
  <p-menu [model]="menuItems" (onHide)="onHideEvent($event)" (onShow)="onShowEvent($event)"></p-menu>
</div>
